<nav class="navbar navbar-expand-lg navbar-light bg-light sticky-top">
    <a class="navbar-brand" routerLink="/support-users/all">
      <img alt="" src="assets/img/Fluidra_Blue.png">
    </a>
</nav>